import React from "react";

const GenericText = ({
  className,
  ...rest
}: React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>) => <div className={`${className} text-md text-secondary`} {...rest} />;

export default GenericText;
